/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackerdef', {
      restrict: 'E',
      bindings: {
        trackerdef: '<',
        index: '<',
        parentsave: '&'
      },
      template: `
          <div class="row">
              <div class="form-group col-xs-12 col-md-3">
                  <label for="trackername">Name/Label*</label>
                  <input class="form-control" id="trackerdefname" ng-model="vm.trackerdef.label" required>
              </div>
              <div class="form-group col-xs-12 col-md-3">
                  <label for="trackerdefunit">Maßeinheit*</label>
                  <input type="text" class="form-control" id="trackerdefunit" ng-model="vm.trackerdef.unit" required>
              </div>
              <div class="form-group col-xs-12 col-md-6">
                  <label for="trackerdefstep">Zahlentyp*</label>
                  <label class="radio-inline"><input type="radio" id="trackerdefstep1" value="1"
                                                     ng-model="vm.trackerdef.step"> Ganzahlig</label>
                  <label class="radio-inline"><input type="radio" id="trackerdefstep2" value="0.1"
                                                     ng-model="vm.trackerdef.step"> Eine Nachkommastelle</label>
                  <label class="radio-inline"><input type="radio" id="trackerdefstep3" value="0.01"
                                                     ng-model="vm.trackerdef.step"> Zwei Nachkommastellen</label>
              </div>
          </div>
          <div class="row">
              <div class="form-group col-xs-6 col-md-3">
                  <label for="trackerdefnormmin">Untere Normgrenze</label>
                  <input type="number" step="{{vm.trackerdef.step}}" class="form-control" id="trackerdefnormmin"
                         required ng-blur="vm.save()"
                         ng-model="vm.trackerdef.normmin">
              </div>
              <div class="form-group col-xs-6 col-md-3">
                  <label for="trackerdefnormmax">Obere Normgrenze</label>
                  <input type="number" step="{{vm.trackerdef.step}}" class="form-control" id="trackerdefnormmax"
                         required ng-blur="vm.save()"
                         ng-model="vm.trackerdef.normmax">
              </div>
              <div class="form-group col-xs-6 col-md-3">
                  <label for="trackerdefabsmin">Absolutes Minimum</label>
                  <input type="number" step="{{vm.trackerdef.step}}" class="form-control" id="trackerdefabsmin"
                         required ng-blur="vm.save()"
                         ng-model="vm.trackerdef.absmin">
              </div>
              <div class="form-group col-xs-6 col-md-3">
                  <label for="trackerdefabsmax">Absolutes Maximum</label>
                  <input type="number" step="{{vm.trackerdef.step}}" class="form-control" id="trackerdefabsmax"
                         required ng-blur="vm.save()"
                         ng-model="vm.trackerdef.absmax">
              </div>
          </div>      
      `,
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          // vm.cancel = cancel;
          // vm.zipsave = zipsave;

          vm.$onInit = function () {
            vm.lasttracker = angular.copy(vm.trackerdef);
          };

          function save() {
            if (!angular.equals(vm.trackerdef, vm.lasttracker)) {
              vm.lasttracker = angular.copy(vm.trackerdef);
              vm.parentsave({trackerdef: vm.trackerdef, index: vm.index});
            }
          }
/*
          function cancel() {
            vm.trackerdef = angular.copy(vm.lasttracker);
            vm.oncancel();
          }*/



        }] // controller
    }); // component

// klammerfriedhof
}());